import {LitElement, svg} from '@isceco/widget-library2/external/lit'
import SchweizerkarteCss from './SchweizerkarteCss.js'
import GasflussDto from './GasflussDto.js'

export default class Schweizerkarte extends LitElement {
  get popups() {
    return {}
  }

  static get styles() {
    return [SchweizerkarteCss]
  }

  static get properties() {
    return {
      data: {type: Array},
      i18n: {type: Object}
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this._parseData()
    window.addEventListener('scroll', this._updatePositions)
    window.addEventListener('resize', this._updatePositions)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this._updatePositions)
    window.removeEventListener('resize', this._updatePositions)
  }

  _updatePositions = () => {
    Object.values(this.popups)
      .forEach(p => this._getPopup(p.code).position(this._getHover(p.code)))
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('data')) {
      this._parseData()
    }
  }

  _parseData = () => {
    this.dataMap = this.data.reduce((accumulator, value) => ({...accumulator, [value.code]: new GasflussDto(value)}), {})
  }

  renderPfeile = () => {
    return svg`
      ${this._pfeilOltingue()}
      ${this._pfeilGriespass()}
      ${this._pfeilWallbach()}
    `
  }

  _pfeilOltingue = () => {
    const ch = this.dataMap['OLTCH'].nominiertRaw
    const transit = this.dataMap['OLTT'].nominiertRaw
    return ch + transit < 0 ? svg`
      <path id="oltingue-ausspeisung" data-name="Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="matrix(0.391, -0.921, 0.921, 0.391, -10230, 2877)" fill="#264d98"/>
    ` : svg`
      <path id="oltingue-einspeisung" data-name="Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="matrix(-0.391, 0.921, -0.921, -0.391, 11174.483, -1997.492)" fill="#264d98"/>
    `
  }

  _pfeilGriespass = () => {
    const ch = this.dataMap['GRIECH'].nominiertRaw
    const transit = this.dataMap['GRIET'].nominiertRaw
    return ch + transit < 0 ? svg`
      <path id="griespass-ausspeisung" data-name="Geplante Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="translate(7069 9661)  rotate(180)" fill="#264d98"/>
    ` : svg`
      <path id="griespass-einspeisung" data-name="Geplante Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="translate(-5775 -8124)" fill="#264d98"/>
    `
  }

  _pfeilWallbach = () => {
    const ch = this.dataMap['WBCH'].nominiertRaw
    const transit = this.dataMap['WBT'].nominiertRaw
    return ch + transit < 0 ? svg`
      <path id="wallbach-ausspeisung" data-name="Geplante Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="translate(-5850 -8500)" fill="#264d98"/>
    ` : svg`
      <path id="wallbach-einspeisung" data-name="Geplante Einspeisung" d="M6426,8905h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm0-4h-8v-2h8v2Zm5-4h-18l9-12,9,12Z" transform="translate(6994 9285)  rotate(180)" fill="#264d98"/>
    `
  }

  _showPopup = (code, event) => {
    this._getPopup(code).show(event.target)
  }

  _hidePopup = code => {
    this._getPopup(code).hide()
  }

  _togglePopup = (code, event) => {
    event.stopPropagation()
    this._getPopup(code).toggle(event.target)
  }

  _getPopup = code => this.shadowRoot.querySelector(`#popup-${code}`)
  _getHover = code => this.shadowRoot.querySelector(`#hover-${code}`)
}
